import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

interface Props {
  active: boolean;
}

export const Container = styled.section<Props>`
  background: ${ColorPalette.HEX.White};
  box-shadow: ${({ theme }) => theme.searchInput.text.boxShadow};
  height: ${({ theme }) => theme.searchInput.text.height};
  max-width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.searchInput.text.padding};
  position: relative;
  border-radius: 8px;
  border: ${({ theme }) => theme.searchInput.text.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const Content = styled.button`
  flex: 1;
  cursor: pointer;
  background: none;
  text-align: left;
  margin-right: 8px;
  ${_ellipsis()};
`;

export const Name = styled.span<Props>`
  font-size: ${({ theme }) => theme.searchInput.text.label.fontSize};
  font-weight: 600;
  line-height: unset;
  ${_ellipsis()};
  color: ${({ theme, active }) =>
    active ? theme.searchInput.text.label.color : theme.searchInput.text.placeholder.label.color};
`;

export const Detail = styled.span<Props>`
  font-size: ${({ theme }) => theme.searchInput.text.detail.fontSize};
  overflow: hidden;
  line-height: unset;
  ${_ellipsis()};
  color: ${({ theme, active }) =>
    active ? theme.searchInput.text.detail.color : theme.searchInput.text.placeholder.detail.color};
`;
